import { matchPath } from "react-router";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import NavigationService from "@ane/core/lib/services/NavigationService";
import { ROUTES } from "@ane/exp-data/lib/routes/Routes.constants";
import { WindowLocation } from "@ane/core/lib/services/WindowService";
import { WORKSPACE_ID } from "@ane/core/lib/constants/QueryString.constants";
import { clearUserAffinity } from "@ane/exp-data/lib/userDetails/GetUserAffinity.utils";
const showStudioExperience = (workspace) => showUnifiedView(workspace);
const showUnifiedView = (workspace, workspaceId) => {
  if (!workspace)
    return false;
  const { IsVNextExpMan, IsMsftWorkspace, IsUnifiedViewOptedIn } = workspace;
  if (EnvironmentService.forceUnifiedView() && !EnvironmentService.forceControlTower() && !IsMsftWorkspace) {
    return true;
  }
  if (EnvironmentService.forceControlTower() && !EnvironmentService.forceUnifiedView() && !IsVNextExpMan) {
    return false;
  }
  var enabledWorkspaceList = EnvironmentService.optInWsIdToUnifiedView().split(",").filter((id) => id !== "");
  if (!IsMsftWorkspace && enabledWorkspaceList.some((id) => id === workspaceId)) {
    return true;
  }
  return !!IsVNextExpMan || !!IsUnifiedViewOptedIn;
};
const navigateToOnboardingPage = () => {
  var _a;
  clearUserAffinity();
  const match = matchPath(WindowLocation.pathname, { path: ROUTES.studio.match.path });
  if (!!((_a = match == null ? void 0 : match.params) == null ? void 0 : _a.workspaceId)) {
    const search = NavigationService.omitQueryParams([WORKSPACE_ID], `${WindowLocation.search}`);
    NavigationService.openExternalLinkInCurrentTab(
      /**
       * Ensure the wsid is from studio path
       */
      `${NavigationService.addParamToPath({
        url: `${ROUTES.onboarding.location.pathname}${search}${WindowLocation.hash}`,
        param: WORKSPACE_ID,
        value: match.params.workspaceId
      })}`
    );
  } else {
    NavigationService.openExternalLinkInCurrentTab(
      `${ROUTES.onboarding.location.pathname}${WindowLocation.search}${WindowLocation.hash}`
    );
  }
};
export {
  navigateToOnboardingPage,
  showStudioExperience,
  showUnifiedView
};
//# sourceMappingURL=GetWorkspace.utils.js.map
